module.exports = __webpack_public_path__ + "img/boton-arriba.e3997dd1.svg";